const registerResource = '/auth/register'

export default {
  register (vue, data, config) {
    return vue.axios.post(`${registerResource}`, data, config)
  }
}
